import { useState, useEffect, useContext } from "react";
import "../../../assets/css/customer/popularProducts/PopularProduct.css";
import { useNavigate } from "react-router-dom";
import { Eye } from "lucide-react";
import AppContext from "../../../context/AppContext";
import axios from "axios";

const PopularProducts = () => {
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFile } = useContext(AppContext);
  const [products, setProducts] = useState([]);
  const [message, setMessage] = useState("");

  useEffect(() => {
    viewPopularProducts();
  }, []);

  const viewPopularProducts = () => {
    axios
      .get(`${baseUrl}/customer/products/viewPopularProducts`)
      .then((response) => {
        console.log(response.data);
        if (response.data.success) {
          setProducts(response.data.products);
        } else {
          setMessage(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <section className="popular-products">
      <div className="products-container">
        <div className="pp-section-header">
          <h2 className="section-title">POPULAR PRODUCTS </h2>
          <p className="section-subtitle">Check out our latest collections</p>
        </div>

        {products.length === 0 ? (
          <div className="pp-empty">
            <h3>{message || "Popular products coming soon!"}</h3>
            <p>Check back soon for our trending picks</p>
          </div>
        ) : (
          <div className="products-grid">
            {products.map((product) => (
              <div key={product.id} className="product-card">
                <div className="product-card-image-wrapper">
                  <img
                    src={`${baseUrlForFile}/${product.productimages[0]?.image_path}`}
                    alt={product.name}
                    className="product-card-image"
                  />

                  <div className="product-overlay">
                    <div className="top-icons">
                      {/* Quick View */}
                      <button
                        className="icon-button view-button"
                        title="Quick View"
                        onClick={() => {
                          navigate(`/product/${product.id}`);
                        }}
                      >
                        <Eye size={20} />
                      </button>
                    </div>
                  </div>
                </div>

                <div className="product-info">
                  <h3 className="product-name">{product.name}</h3>
                  <div className="product-price">
                    <span className="current-price">
                      PKR {product.price.toLocaleString()}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="view-more-container">
          <button
            onClick={() => {
              navigate("/products");
              window.scrollTo(0, 0);
            }}
            className="view-more-button"
          >
            VIEW MORE
          </button>
        </div>
      </div>
    </section>
  );
};

export default PopularProducts;
